function getDefaultExportFromNamespaceIfNotNamed(n) {
  return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

export { getDefaultExportFromNamespaceIfNotNamed as g };
//# sourceMappingURL=_commonjsHelpers-BoiNXpT9-D4KdJQiA.js.map
